import { Token as TokenIcon } from '@mui/icons-material';
import { useNavigate } from 'react-router-dom';
import { Box, Chip } from '@mui/material';

interface TokenDisplayProps {
  tokens: number;
  showBuyButton?: boolean;
}

const TokenDisplay: React.FC<TokenDisplayProps> = ({ 
  tokens, 
  showBuyButton = true
}) => {
  const navigate = useNavigate();

  return (
    <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
      <Chip
        icon={<TokenIcon />}
        label={`${tokens} tokens`}
        color="primary"
        variant="outlined"
        sx={{ color: 'primary.contrastText' }}
        onClick={showBuyButton ? () => navigate('/buy-tokens') : undefined}
        clickable={showBuyButton}
      />
    </Box>
  );
};

export default TokenDisplay; 